import { inject, Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { EnvironmentsConfigsInterface } from '@environments/core/interfaces/environments-configs.interface'
import { PlatformLocation } from '@angular/common'
import { environment } from '@environments/environment'
import { EnvironmentsConfigsLinksCommonInterface } from '@environments/core/interfaces/environments-configs-links-common.interface'
import { EnvironmentsConfigsLinksLangInterface } from '@environments/core/interfaces/environments-configs-links-lang.interface'
import { LanguageService } from '@modules/lang-module/services/language.service'
import { LanguageEnum } from '@modules/lang-module/enums/language.enum'

@Injectable({
	providedIn: 'root',
})
export class EnvironmentsHelperService {
	public environmentsConfigs$: BehaviorSubject<EnvironmentsConfigsInterface | null> =
		new BehaviorSubject<EnvironmentsConfigsInterface | null>(null)

	private readonly _platformLocation: PlatformLocation = inject(PlatformLocation)
	private readonly _languageService: LanguageService = inject(LanguageService)

	get isLocalHost(): boolean {
		return this._platformLocation.hostname === 'localhost'
	}

	get isDev(): boolean {
		return !environment.production
	}

	get domainUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.domain_url ?? null
	}

	get apiUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.api_url ?? null
	}

	get socketUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.socket_url ?? null
	}

	get socketStocksUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.socket_stocks_data ?? null
	}

	get socketOptionsUrl(): string | null {
		return this.environmentsConfigs$.getValue()?.socket_options_data ?? null
	}

	get techWorks(): boolean {
		return !!this.environmentsConfigs$.getValue()?.tech_works
	}

	get linksCommon(): EnvironmentsConfigsLinksCommonInterface | undefined {
		return this.environmentsConfigs$.getValue()?.links?.common
	}

	get linksByLang(): EnvironmentsConfigsLinksLangInterface | undefined {
		const lang: LanguageEnum = this._languageService.language$.getValue()
		return this.environmentsConfigs$.getValue()?.links[lang]
	}
}
